import { createHigherOrderComponent } from '@wordpress/compose';
import { useRef } from '@wordpress/element';

import FeaturedImageVariationsBlockControls from '../components/FeaturedImageVariationsBlockControls';

const { featuredImageVariationsConfig: FEATURED_IMAGE_VARIATIONS_CONFIG } =
  window.mediaPressMediaBlocks;

/**
 * Higher-order component that wraps a block to add featured image variation controls and styling.
 *
 * @param {React.ComponentType<Props>} BlockEdit The original featured image block
 * @return {React.FC<Props>}
 */
const withFeaturedImageVariationBlockControls = createHigherOrderComponent(
  (BlockEdit) => (props) => {
    const { name, attributes, setAttributes, context } = props;
    const wrapperRef = useRef();

    const shouldRender =
      name === 'core/post-featured-image' || (name === 'core/cover' && attributes.useFeaturedImage);

    if (!shouldRender) {
      // eslint-disable-next-line react/jsx-props-no-spreading -- pass through original props
      return <BlockEdit {...props} />;
    }

    return (
      <div ref={wrapperRef}>
        {/* eslint-disable-next-line react/jsx-props-no-spreading -- pass through original props */}
        <BlockEdit {...props} />
        <FeaturedImageVariationsBlockControls
          attributes={attributes}
          setAttributes={setAttributes}
          postType={context.postType}
          postId={context.postId}
          wrapperRef={wrapperRef}
          config={FEATURED_IMAGE_VARIATIONS_CONFIG}
        />
      </div>
    );
  },
  'withFeaturedImageVariationBlockControls',
);

export default withFeaturedImageVariationBlockControls;
